import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { ExportSIEFileButtonProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { StyledButton } from "components/common";
import useSIEFileExportDialog from "./forms/useSIEExportDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ExportSIEFileButton: React.FC<ExportSIEFileButtonProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const exportSIEFileDialog = useSIEFileExportDialog(props.onCreateSuccess);

  const onExportButtonClick = async () => {
    dispatch(displayDialog(exportSIEFileDialog));
  };

  return (
    <StyledButton size="sm" onClick={onExportButtonClick}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.ExportSIEFile)}
    </StyledButton>
  );
};

export default ExportSIEFileButton;
